import { signIn } from '@/lib/auth';
import { esc, setPageTitle } from '@/lib/dom';
import { signInBrand } from '@/lib/host-branding';
import { authCardHeader, readLastEmail, LAST_EMAIL_KEY } from '@/lib/auth-card';
import { renderForgotPassword } from '@/views/forgot-password';

/**
 * `hostname` is a parameter so tests can render both brands; in the app it is
 * always the real address.
 */
export function renderSignIn(root: HTMLElement, hostname: string = location.hostname): void {
  const brand = signInBrand(hostname);
  setPageTitle('Sign in', brand.titleBase);
  const lastEmail = readLastEmail();
  root.innerHTML = `
    <div class="auth">
      <form class="auth-card" id="signin-form" novalidate>
        ${authCardHeader(brand, 'Project Hub — sign in')}

        <label class="field">
          <span>Email</span>
          <input type="email" name="email" autocomplete="email" value="${esc(lastEmail)}" required />
        </label>
        <label class="field">
          <span>Password</span>
          <input type="password" name="password" autocomplete="current-password" required />
        </label>

        <div class="auth-error" id="signin-error" hidden></div>

        <button type="submit" class="btn-primary" id="signin-submit">Sign in</button>
        <button type="button" class="btn-link" data-action="forgot-password">Forgot password?</button>
      </form>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#signin-form')!;
  const errBox = root.querySelector<HTMLDivElement>('#signin-error')!;
  const submit = root.querySelector<HTMLButtonElement>('#signin-submit')!;

  root.querySelectorAll('[data-action="forgot-password"]').forEach((el) => {
    el.addEventListener('click', () => {
      renderForgotPassword(root, { hostname, onBack: () => renderSignIn(root, hostname) });
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;
    submit.disabled = true;
    submit.textContent = 'Signing in…';
    const fd = new FormData(form);
    try {
      const email = String(fd.get('email'));
      await signIn(email, String(fd.get('password')));
      localStorage.setItem(LAST_EMAIL_KEY, email);
      // onAuthChange in main.ts will handle the redirect.
    } catch (err) {
      errBox.hidden = false;
      errBox.innerHTML = esc(err instanceof Error ? err.message : 'Sign-in failed');
      submit.disabled = false;
      submit.textContent = 'Sign in';
    }
  });
}
